import { useEffect, useState } from 'react'
import { translations } from '../../data/translations'
import './GoToTopButton.css'

const GoToTopButton = ({ language }) => {
  const [visible, setVisible] = useState(false)
  const t = translations[language] || translations.de

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 420)
    }

    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })

    return () => {
      window.removeEventListener('scroll', onScroll)
    }
  }, [])

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <button
      type="button"
      className={`go-top-btn ${visible ? 'is-visible' : ''}`}
      onClick={scrollToTop}
      aria-label={t.ui.goTopAriaLabel}
      title={t.ui.goTopLabel}
    >
      <span className="go-top-btn__icon" aria-hidden="true">↑</span>
      <span className="go-top-btn__text">{t.ui.goTopLabel}</span>
    </button>
  )
}

export default GoToTopButton